export const optionsLogLevels = [
    { label: 'Critical', value: 10, backgroundColor: '#E50F26' },
    { label: 'Error', value: 20, backgroundColor: '#e56d7a' },
    { label: 'Warning', value: 30, backgroundColor: 'orange' },
    { label: 'Success', value: 35, backgroundColor: '#7ad537' },
    { label: 'Info', value: 40, backgroundColor: '#3dc3d2' },
    { label: 'Debug', value: 50, backgroundColor: 'purple' },
];
export const logLevelsColors = optionsLogLevels.reduce((obj, item) => ((obj[item.value] = item.backgroundColor), obj), {});
export const logLevelsLabels = optionsLogLevels.reduce((obj, item) => ((obj[item.value] = item.label), obj), {});
